'use client';
import React from 'react';
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterShareButton,
  XIcon,
} from 'react-share';

import {MagicContentArticle} from '@website/types/article.types';
import CopyIcon from '@website/components/shared/svg/CopyIcon';
import {CopyText} from '@website/components/shared/CopyText';
import {Condition} from '@website/constants';
import {useTranslations} from 'next-intl';

interface ShareButtonsProps {
  article: MagicContentArticle | Condition;
  copyText?: string;
}

export function ShareButtons({
  article,
  copyText = 'share', // Input translation key added in ShareButtons object
}: ShareButtonsProps): React.ReactElement {
  const isArticle = 'slug' in article;
  const url = isArticle
    ? `https://wellnite.co/post/${article.slug}`
    : `https://wellnite.com/conditions/${article.route_param}`;
  const t = useTranslations('ShareButtons');

  return (
    <div className="flex items-center space-x-4 pb-10">
      <CopyText
        hoverText={t('copyLinkHover')}
        successText={t('copyLinkSuccess')}
        content={url}
        classes="border hover:border-blue-500 rounded-xl p-2 flex items-center space-x-2 text-sm"
      >
        <CopyIcon width={22} height={22} />
        <span className="inline-block">{t(copyText)}</span>
      </CopyText>

      <FacebookShareButton
        url={url}
        title={article.title}
        className=""
        aria-label={t('shareFacebook')}
      >
        <span className="inline-block border hover:border-blue-500 rounded-xl p-2">
          <FacebookIcon
            size={22}
            iconFillColor="#FFF"
            bgStyle={{fill: '#000'}}
            borderRadius={100}
          />
        </span>
      </FacebookShareButton>
      <TwitterShareButton
        url={url}
        title={article.title}
        aria-label={t('shareTwitter')}
      >
        <span className="inline-block border hover:border-blue-500 rounded-xl p-2">
          <XIcon size={22} borderRadius={10} bgStyle={{fill: '#000'}} />
        </span>
      </TwitterShareButton>
      <LinkedinShareButton
        url={url}
        className="share-button"
        aria-label={t('shareLinkedIn')}
      >
        <span className="inline-block border hover:border-blue-500 rounded-xl p-2">
          <LinkedinIcon size={22} borderRadius={10} bgStyle={{fill: '#000'}} />
        </span>
      </LinkedinShareButton>
    </div>
  );
}
